import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_EVENT_FLOWS_QUERY_KEY } from '@/state/queries/flows/use-get-event-flows';
import type { DeleteFlowDto } from '@/types/dtos/flows/request/delete-flow.dto';
import { GET_EVENT_FILTERED_SESSIONS_QUERY_KEY } from '@/state/queries/sessions/use-filtered-event-sessions';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '@/state/queries/contributors/use-get-event-contributors';
import { invalidatePublicationStateQueries } from '@/state/queries/events/use-publication-state';

export const useDeleteFlowMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (deleteFlowDto: DeleteFlowDto) => {
      const token = await getToken();
      return deleteFlow(deleteFlowDto, token ?? '');
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_FLOWS_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_FILTERED_SESSIONS_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY],
        }),
        invalidatePublicationStateQueries(queryClient),
      ]);
    },
  });
};

const deleteFlow = async (deleteFlowDto: DeleteFlowDto, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/flows/${deleteFlowDto.flowId}`;
  return sendRequest({ url, method: METHOD.DELETE, token });
};
